import { render, staticRenderFns } from "./zDialogoPergunta.vue?vue&type=template&id=77f15db0&scoped=true&"
import script from "./zDialogoPergunta.vue?vue&type=script&lang=js&"
export * from "./zDialogoPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f15db0",
  null
  
)

export default component.exports